import { z } from "zod";

export const SetInitialPasswordReqSchema = z
  .object({
    newPassword: z
      .string()
      .min(8, "パスワードは8文字以上で入力してください")
      .max(32, "パスワードは32文字以下で入力してください")
      .regex(
        /^(?=.*?[a-z])(?=.*?\d)[a-z\d]{8,32}$/i,
        "パスワードは半角英数字混合で入力してください"
      ),
    newPasswordConfirm: z
      .string()
      .min(1, "確認用のパスワードを入力してください"),
  })
  .superRefine(({ newPassword, newPasswordConfirm }, ctx) => {
    if (newPassword !== newPasswordConfirm) {
      ctx.addIssue({
        path: ["newPasswordConfirm"],
        code: "custom",
        message: "パスワードが一致しません",
      });
    }
  });
export type SetInitialPasswordReq = z.infer<typeof SetInitialPasswordReqSchema>;

export const LoginSchema = z.object({
  email: z
    .string()
    .regex(
      /^(?!\.)(?!.*\.\.)([A-Z0-9_+-.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9-]*\.)+[A-Z]{2,}$/i,
      { message: "不正なメールアドレスです" }
    ),
  password: z
    .string({ required_error: "パスワードを入力してください" })
    .nonempty({ message: "パスワードを入力してください" }),
});

export type LoginSchemaReq = z.infer<typeof LoginSchema>;

export const SendResetPasswordEmailSchema = z.object({
  email: z
    .string({ required_error: "メールアドレスを入力してください" })
    .regex(
      /^(?!\.)(?!.*\.\.)([A-Z0-9_+-.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9-]*\.)+[A-Z]{2,}$/i,
      { message: "不正なメールアドレスです" }
    ),
});

export type SendResetPasswordEmailReq = z.infer<
  typeof SendResetPasswordEmailSchema
>;

export const VerifyOTPReqSchema = z.object({
  email: z.string().email("メールアドレスの形式が不正です"),
  token: z // 6桁
    .string()
    .length(6, "トークンは6桁で入力してください")
    .regex(/^\d{6}$/, "トークンは数字6桁で入力してください"),
});

export type VerifyOTPReq = z.infer<typeof VerifyOTPReqSchema>;

export const ResendInviteReqSchema = z.object({
  email: z.string().email("メールアドレスの形式が不正です"),
});
